export default "__VITE_ASSET__DA1WpWL9__"